import React, { useEffect, useMemo, useRef } from 'react'


import HorizonatlBarChart from '../../containers/d3Charts/HorizonatlBarChart'

import * as con from "../../Constants"
import { RefApplicationParameterHook } from '../hooks/ApplicationParamatersHook'

import TerritoryDataLoader from '../data/TerritoryDataLoader'
import { educationGroupSortingFunction, translateEducationGroup } from '../../utils/translateFunctions'


function EducationBarChartByTerritory({includeTerritoryInTitle}) {


        // Object Reference
        const objectReference = useRef()

        // Selected Community and Territory
        const territoryId = RefApplicationParameterHook(con.SELECTED_TERRITORY_ID)

        // Initial Parameters
        const  parameters = useMemo(() => {return({ 
            x : d => translateEducationGroup(d.grupo_escolar),
            y : d => d.total,
            sortingFunction : (a,b) => educationGroupSortingFunction(a.grupo_escolar, b.grupo_escolar),
            group1 : 'total_hombres',
            group2 : 'total_mujeres',
            total : 'total',
            variable : 'grupo_escolar',
            geoIdentifier : 'territorio',
            width : 1800, 
            height : 750, 
            xLabel : "Nivel",
            yLabel : "Personas",
        })},  [])
        
       
        // Territory data
        const dataTerritories = TerritoryDataLoader(con.DATASET_EDUCATION_TERRITORY)

        // Display Mode
        const displayMode = RefApplicationParameterHook(con.DISPLAY_MODE)


        useEffect(() => {
            
            if(dataTerritories.length > 0) 
                HorizonatlBarChart.build(objectReference, dataTerritories, parameters, displayMode)

        }, [dataTerritories, territoryId, parameters, displayMode])

        

        return (
            <div style={{width : "100%"}}>
                {dataTerritories.length > 0 && <svg ref={objectReference} />}
            </div>
        );

}

EducationBarChartByTerritory.defaultProps = {
    includeTerritoryInTitle : false
}


export default EducationBarChartByTerritory